import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewsDetailsComponent } from './news-details.component';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { DynamicComponentLoaderModule } from 'src/app/shared/dynamic-component-loader/dynamic-component-loader.module';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslationsLoader } from 'src/app/service/translations-loader';
import { DYNAMIC_COMPONENT } from 'src/app/shared/dynamic-component-loader/dynamic-component.manifest';
import { PanelsModule } from 'src/app/shared/components/panels/panels.module';

@NgModule({
  declarations: [NewsDetailsComponent],
  exports: [NewsDetailsComponent],
  imports: [
    CommonModule,
    SharedModule,
    DynamicComponentLoaderModule,
    RouterModule,
    PanelsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateModule,
        deps: [HttpClient],
        useClass: TranslationsLoader
      },
    }),
  ],
  providers: [
    {provide: DYNAMIC_COMPONENT, useValue: NewsDetailsComponent},
  ],
})
export class NewsDetailsModule { }
